import { Directive, ElementRef, HostListener, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
  selector: 'input[type="number"]',
  standalone: false
})
export class NumberRangeDirective implements ControlValueAccessor {
  @Input() min?: number;
  @Input() max?: number;
  @Input() decimals?: number;
  @Input() default?: number;

  private onChange: (value: number | undefined) => void = noop;
  private onTouch: () => void = noop;

  constructor(private elRef: ElementRef, @Self() @Optional() private ngControl?: NgControl) {
    if (this.ngControl) this.ngControl.valueAccessor = this;
  }

  set value(inputValue: string) {
    this.elRef.nativeElement.value = inputValue;
  }

  @HostListener('change', ['$event'])
  onTimespanChange({ target: { value: inputValue } }: { target: { value: string } }) {
    const numberMatch = numberRegex.exec(inputValue);

    if (!numberMatch) {
      this.onChange(this.default ?? undefined);
      this.writeValue(this.default ?? undefined);
      return;
    }

    let value = Number(numberMatch[1]);

    if (this.max != null && value != null && value > this.max) value = this.max;
    if (this.min != null && value != null && value < this.min) value = this.min;
    if (this.decimals != null && value != null) value = roundDecimalOrReturnValue(value, this.decimals)!;

    this.writeValue(value);
    this.onChange(value);
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouch: any): void {
    this.onTouch = onTouch;
  }

  writeValue(value?: number): void {
    this.value = `${value != null ? value : ''}`;
  }
}

export const roundDecimal = (value: number, digits: number) => {
  const factor = Math.pow(10, digits);
  return Math.round((value + Number.EPSILON) * factor) / factor;
};

export const roundDecimalOrReturnValue = (value: number | undefined | null, digits: number) => {
  return value ? roundDecimal(value, digits) : value;
};

const numberRegex = /([-+]?[0-9]*\.?[0-9]+)/;
export const noop: any = () => {};
